import { type Control } from 'react-hook-form';
import {
  Stack,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ButtonBase,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HomeWorkIcon from '@mui/icons-material/HomeWork';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { useDialog } from '#packages/web/hooks/use-dialog';

import { DoorTypesDetails } from './details/door-types-details';
import { RoofingDetails } from './details/roofing-details';
import { WallTypesDetails } from './details/wall-types-details';
import { WindowTypesDetails } from './details/window-types-details';

import { DoorTypesFormDialog } from './dialogs/door-types-form-dialog';
import { RoofingFormDialog } from './dialogs/roofing-form-dialog';
import { WallTypesFormDialog } from './dialogs/wall-types-form-dialog';
import { WindowTypesFormDialog } from './dialogs/window-types-form-dialog';

export type EnvelopeFieldsProps = {
  control: Control<EditAuditFormBackgroundData>;
  disableForm: boolean;
};

type SubformType = 'window_types' | 'door_types' | 'wall_types' | 'roofing';

export const EnvelopeFields = ({
  control,
  disableForm,
}: EnvelopeFieldsProps) => {
  const subFormDialog = useDialog<SubformType>();

  return (
    <>
      <Accordion variant="outlined">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header">
          <Stack direction="row" alignItems="center" spacing={1}>
            <HomeWorkIcon fontSize="small" />
            <Typography variant="body1">Envelope</Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={3}>
            <ButtonBase
              disabled={disableForm}
              onClick={() => subFormDialog.open('window_types')}>
              <WindowTypesDetails control={control} />
            </ButtonBase>
            <ButtonBase
              disabled={disableForm}
              onClick={() => subFormDialog.open('door_types')}>
              <DoorTypesDetails control={control} />
            </ButtonBase>
            <ButtonBase
              disabled={disableForm}
              onClick={() => subFormDialog.open('wall_types')}>
              <WallTypesDetails control={control} />
            </ButtonBase>
            <ButtonBase
              disabled={disableForm}
              onClick={() => subFormDialog.open('roofing')}>
              <RoofingDetails control={control} />
            </ButtonBase>
          </Stack>
        </AccordionDetails>
      </Accordion>

      <WindowTypesFormDialog
        control={control}
        onClose={() => subFormDialog.close()}
        open={subFormDialog.data === 'window_types'}
      />
      <DoorTypesFormDialog
        control={control}
        onClose={() => subFormDialog.close()}
        open={subFormDialog.data === 'door_types'}
      />
      <WallTypesFormDialog
        control={control}
        onClose={() => subFormDialog.close()}
        open={subFormDialog.data === 'wall_types'}
      />
      <RoofingFormDialog
        control={control}
        onClose={() => subFormDialog.close()}
        open={subFormDialog.data === 'roofing'}
      />
    </>
  );
};
